import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartyForm_Person_Fragment = graphql(`
  fragment ThirdPartyForm_Person_Fragment on Person {
    # technical fields
    _id
    typeId
    kind
    isInternal
    statusId
    codingConfig {
      strategyId
      kind
    }
    code

    # general info
    internalMemo
    memo
    categoryIds
    birthDate
    isVip
    color
    categoryIds
    firstName
    lastName
    civilityId
    signatureImageUri
    pictureImageUri
    contactInfo {
      _id
      email
      faxNumber
      landlineNumber
      mobileNumber
      professionalNumber
      website
    }

    # addresses
    addresses {
      _id
      typeIds
      postalInfo {
        _id
        postOfficeBox
        postalCode
        region
        route
        streetNumber
        additional
        building
        businessPostCode {
          postalCode
          distributorOfficeNumber
        }
        locality
        inseeCode
        department
        countryAlpha2
      }
      locationInfo {
        _id
        coordinates
        projectionId
        altitude
      }
      cadastralInfo {
        _id
        departmentCode
        districtCode
        municipalityCode
        number
        oldMunicipalityCode
        section
        sheet
      }
      ...AddressesCmp_Address_Fragment
      ...AddressForm_Address_Fragment
    }

    # quotation emitters
    billEmitterIds

    # quotation receiver
    billReceiverId

    # bank info
    bankInfo {
      _id
      accountOwner
      accountNumber
      bankCode
      branchCode
      certificateKey
      domiciliation
      iban
      swift
    }

    # person active memberships
    activeMemberships {
      _id
      organizationId
      functions
      contextualRoleIds
      representativeTypeIds
    }

    ...ThirdPartyForm_PersonGeneralInfoStep_Person_Fragment
    ...ThirdPartyForm_ContactInfoStep_ThirdParty_Fragment
    ...ThirdPartyForm_AddressesStep_ThirdParty_Fragment
    ...ThirdPartyForm_BillEmittersStep_ThirdParty_Fragment
    ...ThirdPartyForm_BillReceiverStep_ThirdParty_Fragment
    ...ThirdPartyForm_BankInfoStep_ThirdParty_Fragment
    ...ThirdPartyForm_PersonMembershipsStep_Person_Fragment
    ...ThirdPartyForm_PersonMembershipsDetailsStep_Person_Fragment
  }
`);

export type ThirdPartyForm_Person = ResultOf<
  typeof ThirdPartyForm_Person_Fragment
>;
